/**
 * Detect image/video from URL and optional MIME type (from API media_type).
 */
export function isMediaImage(url, mediaType) {
  const type = String(mediaType || '').toLowerCase();
  if (type.startsWith('image/') || type === 'image') {
    return true;
  }
  const path = String(url || '').split('?')[0];
  return /\.(jpe?g|jpe|jfif|pjpeg|pjp|png|gif|webp|bmp|svg|tiff?|avif|heic|heif|ico)$/i.test(path);
}

export function isMediaVideo(url, mediaType) {
  const type = String(mediaType || '').toLowerCase();
  if (type.startsWith('video/') || type === 'video') {
    return true;
  }
  const path = String(url || '').split('?')[0];
  return /\.(mp4|m4v|mov|qt|webm|ogg|ogv|mpe?g|mpg|avi|mkv|3gp|3g2|flv|wmv|asf|ts|m2ts|mts)$/i.test(path);
}

export function getMediaMimeType(url, mediaType) {
  const type = String(mediaType || '').toLowerCase();
  if (type.includes('/')) {
    return type;
  }
  const ext = String(url || '').split('?')[0].split('.').pop().toLowerCase();
  const mimeTypes = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    jpe: 'image/jpeg',
    jfif: 'image/jpeg',
    pjpeg: 'image/jpeg',
    pjp: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    bmp: 'image/bmp',
    svg: 'image/svg+xml',
    tif: 'image/tiff',
    tiff: 'image/tiff',
    avif: 'image/avif',
    heic: 'image/heic',
    heif: 'image/heif',
    ico: 'image/x-icon',
    mp4: 'video/mp4',
    m4v: 'video/mp4',
    // Modern .mov is ISO-BMFF; video/quicktime makes Chrome play audio with a black picture.
    mov: 'video/mp4',
    qt: 'video/mp4',
    webm: 'video/webm',
    ogg: 'video/ogg',
    ogv: 'video/ogg',
    mpeg: 'video/mpeg',
    mpg: 'video/mpeg',
    mpe: 'video/mpeg',
    avi: 'video/x-msvideo',
    mkv: 'video/x-matroska',
    '3gp': 'video/3gpp',
    '3g2': 'video/3gpp2',
    flv: 'video/x-flv',
    wmv: 'video/x-ms-wmv',
    asf: 'video/x-ms-asf',
    ts: 'video/mp2t',
    m2ts: 'video/mp2t',
    mts: 'video/mp2t',
  };
  return mimeTypes[ext] || 'application/octet-stream';
}

/** True when we should try rendering as visual media in the feed. */
export function isDisplayableMedia(item) {
  if (!item?.url) {
    return false;
  }
  const mime = item.media_type || item.type;
  return isMediaImage(item.url, mime) || isMediaVideo(item.url, mime);
}
